import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Row, Col } from "antd";
import "../../assets/css/footer.css";

import logo_footer from "../../../src/assets/images/2026/Logos-Botones/IesSeccionMexico.png";
import logo_footer_1 from "../../../src/assets/images/2026/Logos-Botones/IesSeccionMonterrey.png";
import logo_footer_2 from "../../../src/assets/images/2026/Logos-Botones/ExpoElectrica.png";

import twitter from "../../assets/images/2026/Logos-Botones/X.png";
import facebook from "../../assets/images/2026/Logos-Botones/facebook.png";
import instagram from "../../assets/images/2026/Logos-Botones/Instagram.png";

import { Element } from "react-scroll";
import CarouselPatrocinadores2 from "../evento/patrocinadoresLogos";

const Footer = (props) => {
  let location = useLocation();
  console.log(location);
  const { idioma } = props;
  const [hover, setHover] = useState("0");

  return (
    <>
      {location.pathname === "/" ||
      location.pathname === "/registro-" ||
      location.pathname === "/registro-/1" ||
      location.pathname === "/registro-/2" ||
      location.pathname === "/registro-/3" ||
      location.pathname === "/registro-/4" ||
      location.pathname === "/registro-/5" ? (
        <Row justify="center" align="middle">
          <Col xs={{ span: 20 }} md={{ span: 14 }}>
            <br />
            <Link to="/patrocinadores">
              <p className="titulo_seccion_2">NUESTROS PATROCINADORES</p>
            </Link>
            <br />
            <br />
          </Col>

          <Col xs={22} lg={22}>
            <Element name="#patrocinadores" />
            <CarouselPatrocinadores2 num_items={4} />
            <br />
          </Col>
        </Row>
      ) : (
        <></>
      )}

      {location.pathname === "/" || location.pathname === "/registro" ? (
        <Row align="middle" style={{ display: "none" }}>
          <Col xs={{ span: 20, offset: 2 }} md={{ span: 10, offset: 7 }}>
            <br />
            <p className="titulo_seccion_2">MÁS INFORMACIÓN</p>
            <br />
            <br />
          </Col>
          <Col xs={{ span: 16, offset: 4 }} md={{ span: 7, offset: 4 }}>
            <a
              href="mailto:enlace@iesmexico.org"
              target="_blank"
              className="link_informacion"
            >
              enlace@iesmexico.org
            </a>
          </Col>
          <Col xs={24} md={0}>
            <br />
          </Col>
          <Col xs={{ span: 16, offset: 4 }} md={{ span: 7, offset: 2 }}>
            <a
              href="https://api.whatsapp.com/send?phone=5518458117&text=Hola"
              target="_blank"
              className="link_informacion"
            >
              55 1845 8117
            </a>
          </Col>
          <Col span={24}>
            <br />
            <br />
          </Col>
        </Row>
      ) : (
        <></>
      )}
      <Row>
       
      </Row>
      <Row justify="space-around" align="middle" className="contenedor_footer">
        <Col xs={22} lg={12}>
          <Row>
            <Col span={8}>
              <img src={logo_footer} className="logo_footer" alt="logo" />
            </Col>
            <Col span={8}>
              <img src={logo_footer_1} className="logo_footer" alt="logo" />
            </Col>
            <Col span={8}>
              <img src={logo_footer_2} className="logo_footer" alt="logo" />
            </Col>
          </Row>
        </Col>

        <Col xs={24} lg={12}>
          <Row>
            <Col
              xs={{ span: 20, offset: 2 }}
              md={{ span: 14, offset: 10 }}
              style={{ textAlign: "justify" }}
            >
              <a
                href="https://www.facebook.com/IesSeccionMexico/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={facebook}
                  style={{ width: "25px", margin: "2px" }}
                  alt="facebook"
                />
              </a>
              <a
                href="https://www.instagram.com/ies_mexico/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={instagram}
                  style={{ width: "25px", margin: "2px" }}
                  alt="instagram"
                />
              </a>
              <a
                href="https://twitter.com/iesseccionmexic"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={twitter}
                  style={{ width: "25px", margin: "2px" }}
                  alt="x"
                />
              </a>
              <br />
              <br />
              <p className="texto_footer">
                Más información
                <br />
                <a href="mailto:enlace@ies.org" style={{ color: "#faaf3b" }}>
                  enlace@ies.org
                </a>{" "}
                •{" "}
                <a
                  href="https://api.whatsapp.com/send?phone=5518458117&text=Hola"
                  style={{ color: "#faaf3b" }}
                >
                  55 1845 8117
                </a>
                <br />
                <br />
                <p className="texto_footer">
                  Síguenos ennuestras redes y <br />
                  comparte tus fotos utilizando
                  <br />
                  <span style={{ color: "#faaf3b" }}>#SeminarioIES2026</span>
                </p>
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Footer;
